export interface AddressParts {
  street: string;
  city?: string;
  province?: string;
  unitNumber?: string | null;
}

/**
 * Converts a string to title case (first letter of each word capitalized).
 * Examples: "TAMPA" -> "Tampa", "LOS ANGELES" -> "Los Angeles"
 */
function toTitleCase(str: string): string {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function formatStreet(street: string, unitNumber?: string | null): string {
  if (unitNumber) {
    return `${unitNumber} - ${street}`;
  }
  return street;
}

export function formatAddress(parts: AddressParts): string {
  const street = formatStreet(parts.street, parts.unitNumber);

  // Normalize city to title case, keep province as-is (already uppercase like FL, CA)
  const city = parts.city ? toTitleCase(parts.city) : undefined;
  const province = parts.province; // Keep state/province uppercase as-is

  const cityProvince = [city, province]
    .filter(Boolean)
    .join(', ');
  
  if (cityProvince) {
    return `${street}, ${cityProvince}`;
  }

  return street;
}
